<template>
  <v-dialog 
    :value="isOpen"
    persistent
    scrollable
    v-if="isOpen"
    content-class="add-edit-dialog">
    <v-card>
      <v-toolbar class="escalon-dialog-header" height="35">
        <img
          class="modal-axis-logo mr-2"
          src="../../assets/AXIS Logo for Dark Backgrounds - Cropped - Grayscale.png">
        <span>Reset Password</span>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="valid" @submit.prevent="submit">
          <v-container fluid grid-list-md>
            <v-layout wrap>
              <v-flex md3>
                <div>
                  <label class="modal-label">Old Password*</label>
                </div>
                <v-text-field
                  v-model="oldPassword"
                  v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/ }"
                  data-vv-as="Old Password"
                  name="oldPassword"
                  type="password"
                  placeholder="Old Password"
                  solo/>
              </v-flex>
              <v-flex md3>
                <div>
                  <label class="modal-label">New Password*</label>
                </div>
                <v-text-field
                  v-model="newPassword"
                  v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/ }"
                  data-vv-as="New Password"
                  name="newPassword"
                  type="password"
                  placeholder="New Password"
                  solo/>
              </v-flex>
              <v-flex md3>
                <div>
                  <label class="modal-label">Confirm Password*</label>
                </div>
                <v-text-field
                  v-model="confirmPassword"
                  v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/ }"
                  data-vv-as="Confirm Password"
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                  solo/>
              </v-flex>
              <v-flex md3>
                <div>
                  <label class="modal-label">Minimum Requirements</label>
                  <label class="password-requirements">- 1 capital letter</label>
                  <label class="password-requirements">- 1 lowercase letter</label>
                  <label class="password-requirements">- 1 number</label>
                  <label class="password-requirements">- 1 symbol [!@#\$%\^&\*]</label>
                  <label class="password-requirements">- Length of 8</label>
                </div>
              </v-flex>
              <v-flex md12>
                <div class="mb-3">
                  <span class="validation-message">{{ loginErrorMsg }}</span>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text
          @click="cancel"
          class="modal-cta">
          Cancel
          <v-avatar size="20" class="ml-2">
            <img :src="require('../../assets/' + coloredAssetUrls.close)">
          </v-avatar>
        </v-btn>
        <v-btn text
          @click="submit"
          class="modal-cta">
          Set Password
          <v-avatar size="20" class="ml-2">
            <img :src="require('../../assets/' + coloredAssetUrls.submit)">
          </v-avatar>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "changePasswordDialog",
  components: { },
  props: {
    showModal: Boolean
  },
  data() {
    return {
      valid: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      loginErrorMsg: ""
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "usrMustChangePwd"
    ]),
    isOpen() {
      return this.usrMustChangePwd;
    }
  },
  methods: {
    cancel() {
      this.clear();
      this.$store.dispatch("logout")
        .then(() => this.$router.push("login"));
    },
    submit() {
      this.loginErrorMsg = "";
      this.$validator.validateAll()
        .then(valid => {
          if (valid) {
            if (this.newPassword !== this.confirmPassword) {
              this.loginErrorMsg = "The provided passwords did not match.";
              this.clear();
            }
            else if (this.newPassword == this.oldPassword) {
              this.loginErrorMsg = "Old and new passwords cannot be the same.";
              this.clear();
            }
            else {
              // Call action for axios post request.
              this.$store.dispatch("loginChangePass", {
                oldPassword: this.oldPassword,
                newPassword: this.newPassword
              }).then(result => {
                if (result != "SUCCESS") {
                  this.loginErrorMsg = "Error processing the request.";
                } else {
                  let username = this.user.ID;
                  this.$store.dispatch("logout").then(() => 
                    this.$store.dispatch("login", { id: username, password: this.newPassword }))
                    .finally(() => this.$router.push("patients"));
                }
              });
            }
          }
          else {
            this.loginErrorMsg = "The provided password did not meet the minimum requirements.";
            this.clear();
          }
        });
    },
    clear(){
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
    }
  }
};
</script>